/**
 * App.js
 *
 * Copyright (c) apploft. GmbH
 */

import React from 'react';
// @ts-ignore
import api from './de.apploft.generated/api.json';
// @ts-ignore
import colors from './assets/colors.json';
// @ts-ignore
import strings from './assets/strings.json';
import './App.css';
import {Theme} from 'apploft-cloud-forms';
import Portal from './Portal/Portal';

function App() {
  return (
    <React.StrictMode>
      <Theme colors={colors} strings={strings}>
        <Portal api={api} />
      </Theme>
    </React.StrictMode>
  );
}

export default App;
